import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Shortcuts } from './Shortcuts';
import { HelpMenuNavigation } from './HelpMenuNavigation';
import { UserNavigation } from './UserNavigation';
import { Logo } from './Logo';
// import { INTERCOM_SERVICE_URL } from 'config';
import { SystemCurrency } from './SystemCurrency';
import { Notifications } from './Notifications';

// const INTERCOM_ACCESS_TOKEN = process.env.REACT_APP_INTERCOM_ACCESS_TOKEN;

// const fetchUnreadMessagesCount = async () => {
//   const response = await fetch(
//     `${INTERCOM_SERVICE_URL}/conversations?state=open`,
//     {
//       headers: {
//         Authorization: `Bearer ${INTERCOM_ACCESS_TOKEN}`,
//         'Content-Type': 'application/json',
//         'ngrok-skip-browser-warning': 'true',
//       },
//     }
//   );
//   const data = await response.json();
//   return data.conversations.length || 0;
// };

export const Navbar = () => {
  // const [unreadMessages, setUnreadMessages] = useState(0);

  // useEffect(() => {
  //   fetchUnreadMessagesCount().then(setUnreadMessages);
  // }, []);

  return (
    <header className="sticky top-0 z-40 px-6 py-3 bg-transparent backdrop-blur-md flex justify-between items-center">
      <div className="hidden md:block">
        <Logo />
      </div>
      <div className="flex items-center space-x-4">
        <Shortcuts />
        <HelpMenuNavigation />
        <SystemCurrency />
        <Link
          to="/app/conversations"
          className="relative p-2 rounded-full bg-white/10 backdrop-blur-md hover:scale-105 transition"
        >
          <MessageCircle size={20} className="text-white" />
          {/* {unreadMessages > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full">
              {unreadMessages}
            </span>
          )} */}
        </Link>
        <Notifications />
        <UserNavigation />
      </div>
    </header>
  );
};
